import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';

const CONTEXT = 'cms';

export const entriesTransformation = (banners) => {
  let entries = [];
  Object.keys(banners).forEach((locale) => {
    entries = entries.concat(
      banners[locale].reduce(
        (reqData, banner) => reqData.concat({
          fields: appHelpers.setFieldsToEntry({
            [locale]: banner,
          }),
          title: 'banner',
          locale,
          id: banner.id,
        }),
        [],
      ),
    );
  });

  return entries;
};

export const fetchBanners = async (secondHandApproval, jurisdictionId, home = false) => {
  const url = secondHandApproval && !home
    ? DepsService.rest.cms.carousel.second.url
    : DepsService.rest.cms.carousel.first.url;
  const queryParams = { locale: '*' };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const discardBanners = async (jurisdictionId) => {
  const { url } = DepsService.rest.cms.carousel.discard;
  const queryParams = { };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};

export const publishBanners = async (secondHandApproval, jurisdictionId, banners, interval) => {
  const url = secondHandApproval
    ? DepsService.rest.cms.carousel.second.url
    : DepsService.rest.cms.carousel.first.url;
  const entries = entriesTransformation(banners);
  const queryParams = {
    entries,
    properties: {
      interval,
    },
  };
  const urlParams = { jurisdictionId };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};



// WEBPACK FOOTER //
// ./src/modules/app/resources/banners.api.js